import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { ROUTES } from '@/constants/routes';
import { Tabs } from '@/components/Tabs/Tabs';
import { TransactionsEmpty } from '@/components/Profile/Transactions/TransactionsEmpty';
import { TransactionsList } from '@/components/Profile/Transactions/TransactionsList';
import { mockTransactions } from '@/mock-data/transactions';
import NoSsr from '@/components/NoSsr/NoSsr';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';

const tabs = (t: TFunction) => [
  { id: 1, label: t('pages.cabinet.private_account'), link: ROUTES.accountTxs },
  { id: 2, label: t('pages.cabinet.ads'), link: ROUTES.adsTxs },
];

export const TransactionsSection = () => {
  const { t } = useTranslation();
  const { hash: tabType } = useUrlAndHashFromPath();

  const transactions = mockTransactions.filter(tx => tx.type === tabType);

  return (
    <>
      <NoSsr>
        <Tabs tabs={tabs(t)} />
      </NoSsr>

      <NoSsr>
        {transactions.length ? (
          <TransactionsList transactions={transactions} />
        ) : (
          <TransactionsEmpty headerHeight={0} type={tabType} />
        )}
      </NoSsr>
    </>
  );
};
